module.exports = __webpack_public_path__ + "img/09_.4e45f236.jpg";